import React, { useEffect, useState, useRef } from 'react';
import { Tabs  } from 'antd';
import { useSelector } from "react-redux";
import { ObjTest } from '../../util/common';
import { MenuItemVo } from '../../config/menus';
import './index.less';


interface CategoryTabProps {
    options: MenuItemVo[]; // 数据列表
    activeKey: string;  // 默认选中key
    onChange?: (activeKey: string) => void; // 切换面板的回调
}

const RenderLabel = (props: any) => {

    const { item, activeKey, isMobile } = props;

    const [itemWidth, setItemWidth] = useState<number>(0);

    const nameRef = useRef<any>(null);

    useEffect(() => {
        const nameWidth = nameRef.current ? nameRef.current.offsetWidth : 0;
        if (nameWidth > 0) {
            setItemWidth(nameWidth);
        }
    }, [nameRef]);


    const menuNameStyle = {
        color: activeKey === item.menuId ? '#FF1D38' : '#666',
        fontSize: isMobile ? '20px' : '24px',
    };
    const englishNameStyle = {
        color: activeKey === item.menuId ? '#FF1D38' : '#9E9E9E',
    };
    
    
    return (
        <div>
            <span ref={nameRef} className="ftl" style={menuNameStyle}>{item.menuName}</span>
            <p className="lh18" style={{...englishNameStyle, width: itemWidth, whiteSpace: 'normal', overflowWrap: 'break-word', wordBreak: 'keep-all'}}>{item.englishName || 'English Name'}</p>
        </div>
    );
};



/**
 * 分类导航切换tabs
 */
const CategoryTabs = (props: CategoryTabProps) => {
    
    let { options, activeKey = null, onChange } = props;

    const { isMobile } = useSelector((state: any) => state.reducer); 
    
    // 加入全部
    const list = [
        { menuId: null, menuName: '全部', englishName: 'ALL' },
        ...options
    ];

    return (
        <Tabs
            activeKey={activeKey}
            tabPosition="top"
            className="category-tabs"
            style={{ height: 60 }}
            items={list.map((v: MenuItemVo, i: number) => {
                return {
                    key: v.menuId,
                    label: <RenderLabel isMobile={isMobile} activeKey={activeKey} item={v} />
                };
            })}
            onChange={(key: string) => onChange(['null', 'undefined'].includes(key) ? null : key)}
        />
    );

};
export { CategoryTabs };